/**
 * Categories used by nodes in a Flow Model diagram
 */
export enum NodeCategory {
  ACTIVITY = 'activity',
  EXCLUSIVE_GATEWAY = 'exclusiveGateway',
  DIVERGE_GATEWAY = 'divergeGateway',
  CONVERGE_GATEWAY = 'convergeGateway',
  COMPONENT = 'component',
  EVENT = 'event',
  POOL = 'Pool',
  LANE = 'Lane',
  LINK = 'link'
}
